var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 8.95703L6.94141 8.14844L1.31641 2.52344L0.507812 1.75L2.125 0.132812L2.89844 0.941406L7.75 5.75781L12.5664 0.941406L13.375 0.132812L14.957 1.75L14.1484 2.52344L8.52344 8.14844L7.75 8.95703Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandForecast);
export default __webpack_public_path__ + "static/media/expand_forecast.6f350637cae03f927ec8ed1e484164d1.svg";
export { ForwardRef as ReactComponent };